import React, { FunctionComponent } from 'react';

import { withErrorBoundary } from '../../helpers/hocs/with-error-boundary';
import { usePromozavrRuntimeController } from './runtime-controller';

export const PromozavrRuntimeComponent: FunctionComponent = () => {
    const { PromoRenderer, promoRendererProps, renderKey } = usePromozavrRuntimeController();

    if (!promoRendererProps) {
        return null;
    }

    return <PromoRenderer key={renderKey} {...promoRendererProps} />;
};

export const PromozavrRuntime = withErrorBoundary(PromozavrRuntimeComponent);
